import script from "./TradeWelcomeBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeWelcomeBoard.vue?vue&type=script&setup=true&lang=js"

import "./TradeWelcomeBoard.vue?vue&type=style&index=0&id=b1e4205c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b1e4205c"]])

export default __exports__